import { render, staticRenderFns } from "./LetterGradeDetailTable.vue?vue&type=template&id=04f94b82"
import script from "./LetterGradeDetailTable.vue?vue&type=script&lang=js"
export * from "./LetterGradeDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports